import { useEffect, useState } from 'react';
import { Plus, Pencil } from 'lucide-react';
import { api } from '../api/client';
import { Modal } from '../components/ui/Modal';
import { Badge } from '../components/ui/Badge';

export function AdminSecretariasPage() {
  const [lista, setLista] = useState([]);
  const [editing, setEditing] = useState(null);

  const load = () => api.get('/secretarias').then((r) => setLista(r.secretarias));
  useEffect(() => { load(); }, []);

  const salvar = async (form) => {
    if (form.id) await api.patch(`/secretarias/${form.id}`, form);
    else await api.post('/secretarias', form);
    setEditing(null);
    load();
  };

  return (
    <div className="page">
      <div className="page-header">
        <div>
          <h1 className="page-title">Secretarias</h1>
          <p className="page-subtitle">Cadastro de secretarias que solicitam comunicação.</p>
        </div>
        <button className="btn btn-primary" onClick={() => setEditing({})}>
          <Plus size={16} /> Nova secretaria
        </button>
      </div>

      <div className="card"><div className="card-body" style={{ padding: 0 }}>
        <div className="table-wrap">
          <table className="table">
            <thead>
              <tr><th>Nome</th><th>Slug</th><th>Status</th><th></th></tr>
            </thead>
            <tbody>
              {lista.map((s) => (
                <tr key={s.id}>
                  <td><strong>{s.nome}</strong></td>
                  <td className="text-sm muted">{s.slug}</td>
                  <td>{s.ativo ? <Badge color="success">Ativa</Badge> : <Badge color="danger">Inativa</Badge>}</td>
                  <td><button className="btn btn-ghost btn-sm" onClick={() => setEditing(s)}><Pencil size={14} /></button></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div></div>

      {editing && <SecretariaModal item={editing} onClose={() => setEditing(null)} onSave={salvar} />}
    </div>
  );
}

function SecretariaModal({ item, onClose, onSave }) {
  const [form, setForm] = useState({
    id: item.id,
    nome: item.nome || '',
    slug: item.slug || '',
    ativo: item.ativo ?? true,
  });
  const [saving, setSaving] = useState(false);

  const slugFromNome = (n) => n.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try { await onSave(form); }
    finally { setSaving(false); }
  };

  return (
    <Modal open={true} onClose={onClose} title={item.id ? 'Editar secretaria' : 'Nova secretaria'}>
      <form onSubmit={submit} className="stack">
        <div className="field">
          <label>Nome</label>
          <input
            className="input"
            required
            value={form.nome}
            onChange={(e) => setForm((f) => ({ ...f, nome: e.target.value, slug: f.id ? f.slug : slugFromNome(e.target.value) }))}
          />
        </div>
        <div className="field">
          <label>Slug</label>
          <input className="input" required pattern="[a-z0-9-]+" value={form.slug} onChange={(e) => setForm((f) => ({ ...f, slug: e.target.value }))} />
        </div>
        {item.id && (
          <label className="row" style={{ gap: 8 }}>
            <input type="checkbox" checked={form.ativo} onChange={(e) => setForm((f) => ({ ...f, ativo: e.target.checked }))} />
            Ativa
          </label>
        )}
        <div className="row" style={{ justifyContent: 'flex-end', gap: 10 }}>
          <button type="button" className="btn btn-secondary" onClick={onClose}>Cancelar</button>
          <button type="submit" className="btn btn-primary" disabled={saving}>{saving ? 'Salvando...' : 'Salvar'}</button>
        </div>
      </form>
    </Modal>
  );
}
